import type { PixelSprite } from '../types.js';
const variant0: PixelSprite = {
  layers: [
    {
      paint: [
        ['market', 0.76],
        ['shadow', 0.24],
      ],
      d: 'M-3,-3h1.5v0.5h-1.5zM3,-3h0.5v0.5h-0.5zM-3,-2.5h0.5v0.5h-0.5zM2,-2.5h1.5v1h-1.5zM-3.5,-1.5h0.5v1h-0.5zM-2.5,-1.5h0.5v0.5h-0.5zM2.5,-1.5h1v0.5h-1zM0,-1h0.5v0.5h-0.5zM1,-1h2.5v0.5h-2.5zM0.5,-0.5h3v0.5h-3zM-2,0h0.5v0.5h-0.5zM0.5,0h2v0.5h-2zM0,0.5h1.5v0.5h-1.5z',
    },
    {
      paint: 'trunk',
      d: 'M3.5,-5h0.5v0.5h-0.5zM-4,-3.5h0.5v0.5h-0.5zM-4,-3h1v1.5h-1zM3.5,-3h0.5v3h-0.5zM-4,-1.5h0.5v1.5h-0.5z',
    },
    {
      paint: 'marketAwning',
      d: 'M-1.5,-6.5h0.5v0.5h-0.5zM-1,-6h2v0.5h-2zM0,-5.5h3v0.5h-3zM2,-5h1.5v0.5h-1.5zM3,-4.5h1v0.5h-1zM-1.5,-3.5h0.5v0.5h-0.5zM1,-3h0.5v0.5h-0.5z',
    },
    {
      paint: [
        ['marketAwning', 0.78],
        ['sail', 0.22],
      ],
      d: 'M-2,-6h1v0.5h-1zM-2.5,-5.5h0.5v0.5h-0.5zM-1,-5.5h1v0.5h-1zM-3.5,-5h1v1h-1zM1,-5h1v0.5h-1zM2.5,-4.5h0.5v0.5h-0.5zM-2.5,-4h2.5v0.5h-2.5zM3.5,-4h0.5v0.5h-0.5zM-1,-3.5h4v0.5h-4zM0,-3h1v0.5h-1zM-2.5,-2.5h0.5v0.5h-0.5zM-1.5,-2.5h0.5v0.5h-0.5zM1.5,-2.5h0.5v0.5h-0.5zM-3,-2h0.5v0.5h-0.5zM-2,-1.5h1v0.5h-1z',
    },
    {
      paint: 'sail',
      d: 'M-2,-5.5h0.5v0.5h-0.5zM-2.5,-5h3v0.5h-3zM-2,-4.5h4.5v0.5h-4.5zM0,-4h3v0.5h-3z',
    },
    {
      paint: [
        ['marketAwning', 0.76],
        ['shadow', 0.24],
      ],
      d: 'M-4,-4.5h0.5v0.5h-0.5zM-4,-4h1.5v0.5h-1.5zM4,-4h0.5v0.5h-0.5zM-3.5,-3.5h2v0.5h-2zM3,-3.5h1.5v0.5h-1.5zM-1.5,-3h1.5v0.5h-1.5zM1.5,-3h1.5v0.5h-1.5zM0,-2.5h1.5v0.5h-1.5zM-1,-2h0.5v1h-0.5z',
    },
    {
      paint: 'fence',
      d: 'M-1,-2.5h1v0.5h-1zM-0.5,-2h1v0.5h-1zM1.5,-2h0.5v0.5h-0.5zM-0.5,-1.5h1.5v0.5h-1.5zM1.5,-1.5h1v0.5h-1zM0.5,-1h0.5v0.5h-0.5zM-3.5,-0.5h0.5v0.5h-0.5z',
    },
    {
      paint: [
        ['market', 0.78],
        ['sail', 0.22],
      ],
      d: 'M-1.5,-5.5h0.5v0.5h-0.5zM0.5,-5h0.5v0.5h-0.5zM-2.5,-4.5h0.5v0.5h-0.5zM3,-4h0.5v0.5h-0.5zM-3,-1.5h0.5v0.5h-0.5zM-3,-1h3v0.5h-3zM-3,-0.5h3.5v0.5h-3.5zM-1.5,0h2v0.5h-2z',
    },
    { paint: 'orchardFruit', d: 'M-2,-2.5h0.5v0.5h-0.5zM-2.5,-2h1.5v0.5h-1.5z' },
    { paint: 'wheat', d: 'M0.5,-2h1v0.5h-1zM1,-1.5h0.5v0.5h-0.5z' },
  ],
  pixels: 191,
};
const variant1: PixelSprite = {
  layers: [
    {
      paint: [
        ['market', 0.76],
        ['shadow', 0.24],
      ],
      d: 'M-3,-3h1.5v0.5h-1.5zM3,-3h0.5v0.5h-0.5zM-3,-2.5h0.5v0.5h-0.5zM2,-2.5h1.5v1h-1.5zM-3.5,-1.5h0.5v1h-0.5zM-2.5,-1.5h0.5v0.5h-0.5zM2.5,-1.5h1v0.5h-1zM0,-1h0.5v0.5h-0.5zM1,-1h2.5v0.5h-2.5zM0.5,-0.5h3v0.5h-3zM-2,0h0.5v0.5h-0.5zM0.5,0h2v0.5h-2zM0,0.5h1.5v0.5h-1.5z',
    },
    {
      paint: 'trunk',
      d: 'M3.5,-5h0.5v0.5h-0.5zM-4,-3.5h0.5v0.5h-0.5zM-4,-3h1v1.5h-1zM3.5,-3h0.5v2.5h-0.5zM-4,-1.5h0.5v1.5h-0.5zM3.5,-0.5h2v0.5h-2zM6,-0.5h1.5v0.5h-1.5zM4,0h1v0.5h-1zM6,0h1v0.5h-1z',
    },
    {
      paint: 'marketAwning',
      d: 'M-1.5,-6.5h0.5v0.5h-0.5zM-1,-6h2v0.5h-2zM0,-5.5h3v0.5h-3zM2,-5h1.5v0.5h-1.5zM3,-4.5h1v0.5h-1zM-1.5,-3.5h0.5v0.5h-0.5zM1,-3h0.5v0.5h-0.5z',
    },
    {
      paint: [
        ['marketAwning', 0.78],
        ['sail', 0.22],
      ],
      d: 'M-2,-6h1v0.5h-1zM-2.5,-5.5h0.5v0.5h-0.5zM-1,-5.5h1v0.5h-1zM-3.5,-5h1v1h-1zM1,-5h1v0.5h-1zM2.5,-4.5h0.5v0.5h-0.5zM-2.5,-4h2.5v0.5h-2.5zM3.5,-4h0.5v0.5h-0.5zM-1,-3.5h4v0.5h-4zM0,-3h1v0.5h-1zM-2.5,-2.5h0.5v0.5h-0.5zM-1.5,-2.5h0.5v0.5h-0.5zM1.5,-2.5h0.5v0.5h-0.5zM-3,-2h0.5v0.5h-0.5zM-2,-1.5h1v0.5h-1z',
    },
    {
      paint: 'sail',
      d: 'M-2,-5.5h0.5v0.5h-0.5zM-2.5,-5h3v0.5h-3zM-2,-4.5h4.5v0.5h-4.5zM0,-4h3v0.5h-3z',
    },
    {
      paint: [
        ['marketAwning', 0.76],
        ['shadow', 0.24],
      ],
      d: 'M-4,-4.5h0.5v0.5h-0.5zM-4,-4h1.5v0.5h-1.5zM4,-4h0.5v0.5h-0.5zM-3.5,-3.5h2v0.5h-2zM3,-3.5h1.5v0.5h-1.5zM-1.5,-3h1.5v0.5h-1.5zM1.5,-3h1.5v0.5h-1.5zM0,-2.5h1.5v0.5h-1.5zM-1,-2h0.5v1h-0.5z',
    },
    {
      paint: 'fence',
      d: 'M-1,-2.5h1v0.5h-1zM4,-2.5h2.5v0.5h-2.5zM-0.5,-2h1v0.5h-1zM1.5,-2h0.5v0.5h-0.5zM5,-2h1.5v0.5h-1.5zM-0.5,-1.5h1.5v0.5h-1.5zM1.5,-1.5h1v0.5h-1zM0.5,-1h0.5v0.5h-0.5zM-3.5,-0.5h0.5v0.5h-0.5z',
    },
    {
      paint: [
        ['market', 0.78],
        ['sail', 0.22],
      ],
      d: 'M-1.5,-5.5h0.5v0.5h-0.5zM0.5,-5h0.5v0.5h-0.5zM-2.5,-4.5h0.5v0.5h-0.5zM3,-4h0.5v0.5h-0.5zM-3,-1.5h0.5v0.5h-0.5zM-3,-1h3v0.5h-3zM-3,-0.5h3.5v0.5h-3.5zM-1.5,0h2v0.5h-2z',
    },
    { paint: 'orchardFruit', d: 'M-2,-2.5h0.5v0.5h-0.5zM-2.5,-2h1.5v0.5h-1.5z' },
    { paint: 'wheat', d: 'M0.5,-2h1v0.5h-1zM1,-1.5h0.5v0.5h-0.5z' },
    {
      paint: 'cart',
      d: 'M4,-2h1v0.5h-1zM6.5,-2h1v0.5h-1zM4,-1.5h3.5v0.5h-3.5zM4,-1h3v0.5h-3zM5.5,-0.5h0.5v0.5h-0.5z',
    },
  ],
  pixels: 227,
};
const variant2: PixelSprite = {
  layers: [
    {
      paint: 'trunk',
      d: 'M3.5,-5h0.5v0.5h-0.5zM-4,-3.5h0.5v0.5h-0.5zM-4,-3h1v1.5h-1zM3.5,-3h0.5v3h-0.5zM-4,-1.5h0.5v1h-0.5zM-4,-0.5h1v0.5h-1zM1,0.5h0.5v0.5h-0.5z',
    },
    {
      paint: 'marketAwning',
      d: 'M-1.5,-6.5h0.5v0.5h-0.5zM-1,-6h2v0.5h-2zM0,-5.5h3v0.5h-3zM2,-5h1.5v0.5h-1.5zM3,-4.5h1v0.5h-1zM-1.5,-3.5h0.5v0.5h-0.5zM0,-3h0.5v0.5h-0.5zM1,-3h0.5v0.5h-0.5z',
    },
    {
      paint: [
        ['marketAwning', 0.78],
        ['sail', 0.22],
      ],
      d: 'M-2,-6h1v0.5h-1zM-2.5,-5.5h0.5v0.5h-0.5zM-1,-5.5h1v0.5h-1zM-3.5,-5h1v1h-1zM1,-5h1v0.5h-1zM2.5,-4.5h0.5v0.5h-0.5zM-2.5,-4h2.5v0.5h-2.5zM3.5,-4h0.5v0.5h-0.5zM-1,-3.5h4v0.5h-4zM0.5,-3h0.5v0.5h-0.5zM-1.5,-2.5h0.5v0.5h-0.5zM-2,-1.5h1v0.5h-1z',
    },
    {
      paint: 'sail',
      d: 'M-2,-5.5h0.5v0.5h-0.5zM-2.5,-5h3v0.5h-3zM-2,-4.5h4.5v0.5h-4.5zM0,-4h3v0.5h-3z',
    },
    {
      paint: [
        ['marketAwning', 0.76],
        ['shadow', 0.24],
      ],
      d: 'M-4,-4.5h0.5v0.5h-0.5zM-4,-4h1.5v0.5h-1.5zM4,-4h0.5v0.5h-0.5zM-3.5,-3.5h2v0.5h-2zM3,-3.5h1.5v0.5h-1.5zM-2.5,-3h2.5v0.5h-2.5zM1.5,-3h2v0.5h-2zM0,-2.5h2.5v0.5h-2.5zM-3,-2h0.5v0.5h-0.5zM-1,-2h0.5v1h-0.5z',
    },
    {
      paint: 'fence',
      d: 'M-1,-2.5h1v0.5h-1zM-0.5,-2h1v0.5h-1zM1.5,-2h0.5v0.5h-0.5zM2.5,-2h0.5v0.5h-0.5zM-3.5,-1.5h0.5v1h-0.5zM-0.5,-1.5h1.5v0.5h-1.5zM1.5,-1.5h1v0.5h-1zM0,-1h1.5v0.5h-1.5z',
    },
    {
      paint: [
        ['market', 0.78],
        ['sail', 0.22],
      ],
      d: 'M-1.5,-5.5h0.5v0.5h-0.5zM0.5,-5h0.5v0.5h-0.5zM-2.5,-4.5h0.5v0.5h-0.5zM3,-4h0.5v0.5h-0.5zM-3,-1.5h0.5v0.5h-0.5zM-3,-1h3v0.5h-3zM-3,-0.5h3.5v0.5h-3.5zM-1.5,0h2v0.5h-2zM0,0.5h0.5v0.5h-0.5z',
    },
    {
      paint: [
        ['market', 0.76],
        ['shadow', 0.24],
      ],
      d: 'M-2.5,-1.5h0.5v0.5h-0.5zM2.5,-1.5h1v0.5h-1zM1.5,-1h2v0.5h-2zM0.5,-0.5h3v0.5h-3zM0.5,0h2v0.5h-2zM0.5,0.5h0.5v0.5h-0.5z',
    },
    { paint: 'orchardFruit', d: 'M-2.5,-2.5h1v0.5h-1zM-2.5,-2h1.5v0.5h-1.5z' },
    { paint: 'wheat', d: 'M0.5,-2h1v0.5h-1zM2,-2h0.5v0.5h-0.5zM1,-1.5h0.5v0.5h-0.5z' },
  ],
  pixels: 185,
};
export const sprites: readonly PixelSprite[] = [variant0, variant1, variant2];
